import { render, staticRenderFns } from "./FrameIoDropdown.vue?vue&type=template&id=bfdc75ae&scoped=true&"
import script from "./FrameIoDropdown.vue?vue&type=script&lang=js&"
export * from "./FrameIoDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FrameIoDropdown.vue?vue&type=style&index=0&id=bfdc75ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdc75ae",
  null
  
)

export default component.exports